<template>
<div>
    <!-- modal -->
    <b-modal id="plantVarietyReformerFormModal" centered size="lg" no-close-on-backdrop ref="plantVarietyReformerFormModal" :title="$t('plantVarietyReformer.info')" @close="clear()" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="infoRules" tag="form">
            <b-row>
                <b-col class="col-md-12">
                    <b-form>
                        <label for="plantVarietyReformer-Name-input">{{ $t('plantVarietyReformer.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name="$t('plantVarietyReformer.name')" rules="required">
                                <b-form-input size="sm" id="plantVarietyReformer-Name-input" v-model="plantVarietyReformerName" maxlength="100" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12 mb-1">
                    <b-form>
                        <validation-provider :name="$t('plantVarietyReformer.country')" #default="{ errors }" :rules="{ excluded: 0 }">
                            <label for="country-input">{{ $t('plantVarietyReformer.country') }}</label>
                            <b-form-select v-model="countrySelect" value-field="id" text-field="name" size="sm" :options="countryOption" />
                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                {{ errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12">
                    <label for="textarea-default">{{ $t('plantVarietyReformer.address') }}</label>
                    <validation-provider #default="{ errors }" :name="$t('plantVarietyReformer.address')" rules="required">
                        <b-form-textarea size="sm" id="textarea-default" :placeholder="$t('plantVarietyReformer.address')" v-model="inventorAddress" rows="2" maxlength="250" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getPlantVarietyReformerList: {
            type: Function
        },
        getPlantVarietyList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            plantVarietyId: 0,
            plantVarietyReformerName: '',
            inventorAddress: '',
            countryOption: [],
            countrySelect: 0,
        }
    },
    methods: {
        showInfo(id, plantVarietyId) {
            this.$refs['plantVarietyReformerFormModal'].show()
            this.id = id
            this.plantVarietyId = plantVarietyId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'PlantVarietyReformer'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.plantVarietyReformerName = response.data.plantVarietyReformer.name
                    this.inventorAddress = response.data.plantVarietyReformer.address
                    this.nationalityIDNumber = response.data.plantVarietyReformer.nationalityIDNumber
                    this.countrySelect = response.data.plantVarietyReformer.countryId
                    this.countryOption = response.data.countryList
                    this.countryOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('plantVarietyReformerFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.plantVarietyReformerName = null
            this.inventorAddress = null
            this.countrySelect = 0
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                plantVarietyId: this.plantVarietyId,
                name: this.plantVarietyReformerName,
                address: this.inventorAddress,
                countryId: this.countrySelect,
            }
            const controller = {
                name: 'PlantVarietyReformer'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('plantVarietyReformerFormModal')
                            this.getPlantVarietyReformerList()
                            this.$SaveAlert()
                            this.getPlantVarietyList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
